import translationalTeamApi from "../../api/translationalTeams";
import studentOpportunitiesApi from "../../api/studentOpportunity";

const state = {
  newStudentOpportunity: {
    asuriteId: null,
    opportunityId: null,
    studentOpportunityTypeId: null
  },
  studentOpportunityTypes: [],
  translationalTeam: {}
};

const getters = {};

const actions = {
  getTranslationalTeam(context, translationalTeamId) {
    translationalTeamApi
      .getTranslationalTeam(translationalTeamId)
      .then(function(response) {
        context.commit("updateTranslationalTeam", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getStudentOpportunityTypes(context) {
    studentOpportunitiesApi
      .getStudentOpportunityTypes()
      .then(function(response) {
        context.commit("updateStudentOpportunityTypes", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  addStudentOpportunity(context) {
    return new Promise((resolve, reject) => {
      studentOpportunitiesApi
        .postStudentOpportunity(context.state.newStudentOpportunity)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  resetStudentOpportunity(context) {
    context.commit("updateOpportunityId", null);
    context.commit("updateStudentAsuriteId", null);
    context.commit("updateStudentOpportunityTypeId", null);
    context.commit("updatePrimarySelection", null);
  }
};

const mutations = {
  updateOpportunityId(state, value) {
    state.newStudentOpportunity.opportunityId = value;
  },

  updateStudentAsuriteId(state, value) {
    state.newStudentOpportunity.asuriteId = value;
  },

  updateStudentOpportunityTypeId(state, value) {
    state.newStudentOpportunity.studentOpportunityTypeId = value;
  },

  updatePrimarySelection(state, value) {
    state.newStudentOpportunity.primarySelection = value;
  },

  updateStudentOpportunityTypes(state, value) {
    state.studentOpportunityTypes = value;
  },

  updateTranslationalTeam(state, value) {
    state.translationalTeam = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
